import React from 'react';
import styles from './Section2.module.css';

const services = [
  ['01', 'Геодезическо заснемане', 'На имоти, сгради и съоръжения — с данни, на които можете да се доверите.'],
  ['02', 'Трасиране', 'Точно позициониране на имоти, сгради и съоръжения на терен.'],
  ['03', 'Кадастрални услуги', 'Проекти за кадастъра и промени в кадастралната карта.'],
  ['04', 'Устройствено планиране', 'Регулационни планове, ПУП и вертикално планиране.'],
  ['05', 'Специализирани снимки', 'Тахиметрични снимки и заснемане на земеделски земи.'],
  ['06', 'Делби на имоти', 'Съдействие при разделяне и уреждане на имоти.'],
];

const Section2: React.FC = () => (
  <section id="section2" className={styles.section}>
    <div className={styles.heading}><p>Нашите услуги</p><h2>Всичко необходимо за Вашия обект.</h2><span>Работим прецизно, в срок и с коректно отношение към всяка задача.</span></div>
    <div className={styles.grid}>{services.map(([number, title, description]) => <article className={styles.card} key={number}><span>{number}</span><h3>{title}</h3><p>{description}</p><i>↗</i></article>)}</div>
  </section>
);
export default Section2;
